export enum PixKeyType {
    default = 0,
    phone = 1,
    email = 2,
    cpf_cnpj = 3,
    randomized = 4,
    
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/PixKeyType.ts